/* eslint-disable */
const EmagineBlocks = {
	/**
	 * Placeholder for components that should be initialized.
	 * @type {Object}
	 */
	components: {},

	/**
	 * Add events to hook into at various points in the setup process.
	 */
	dispatchEvents() {
		/**
		 * Triggered before components are added.
		 */
		const setupEvent = new CustomEvent('EmagineBlocks:setup');
		window.dispatchEvent(setupEvent);

		/**
		 * Triggered during initialization.
		 */
		const initEvent = new CustomEvent('EmagineBlocks:init');
		window.dispatchEvent(initEvent);

		/**
		 * Triggered after components are initialized.
		 */
		const loadedEvent = new CustomEvent('EmagineBlocks:loaded');
		window.dispatchEvent(loadedEvent);
	},

	/**
	 * Add a new component to EmagineBlocks.components.
	 * @param  {String} componentName    (Required) The name of the component.
	 * @param  {Class} 	componentClass   (Required) Reference to the component's class.
	 * @param  {Object} componentOptions (Optional) Object of component options.
	 */
	addComponent(componentName, componentClass, componentOptions) {
		this.components[componentName] = {
			name: componentName,
			class: componentClass,
			options: componentOptions
		};
	},

	/**
	 * Remove the component from EmagineBlocks.components.
	 * @param  {String} componentName Name of the component to remove.
	 */
	removeComponent(componentName) {
		delete this.components[componentName];
	},

	/**
	 * Created a new instance of the supplied component.
	 * @param  {Object} component (Required) Object containing name, class, and options.
	 */
	initComponent(component) {
		this.components[component.name].instance = new component.class(component.options);
	},

	/**
	 * Global init funciton that initializes all components in EmagineBlocks.components.
	 */
	init() {
		for (let component in this.components) {
			this.initComponent(this.components[component])
		}
	}
}

export { EmagineBlocks };
/* eslint-enable */
